import React, {useState, lazy} from 'react';
import MapboxHelpTooltip from './MapboxHelpTooltip.jsx';
import PhaseCollapser from '../../../../monitoring_report/edit/PhaseCollapser.jsx';

const CodeEditor = lazy(() => import('@uiw/react-textarea-code-editor'));
const AdvancedSetting = ({update, setting, title, description}) => {
    const [isAdvancedShown, setIsAdvancedShown] = useState(false);
    return (
        <div className='col-xs-12 col-md-12 '>
            <PhaseCollapser isCollapsed={!isAdvancedShown} handleClick={() => setIsAdvancedShown(!isAdvancedShown)} />
            <label className={`col-xs-12 col-md-12 ${isAdvancedShown ? '' : 'visibility-hidden'}`}>
                {title}
                <MapboxHelpTooltip description={description} />
                <CodeEditor
                    value={setting}
                    language="json"
                    placeholder={I18n.t('enter_formula_placeholder')}
                    onChange={(evn) => update(evn.target.value)}
                    data-color-mode='light'
                    style={{
                    fontSize: 12,
                    fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                    maxWidth: '800px',
                    minWidth: '200px'
                    }}
                />
            </label>
        </div>
    )
}

export default AdvancedSetting